import { render, staticRenderFns } from "./TaxReportRentalObjectSummary.vue?vue&type=template&id=96d8798c&scoped=true&"
import script from "./TaxReportRentalObjectSummary.vue?vue&type=script&lang=js&"
export * from "./TaxReportRentalObjectSummary.vue?vue&type=script&lang=js&"
import style0 from "./TaxReportRentalObjectSummary.vue?vue&type=style&index=0&id=96d8798c&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "96d8798c",
  null
  
)

export default component.exports